import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import dataTestValue from 'src/utils/testUtils';

type SelectWrapperProps = { label: string; value?: any | null };

export const SelectWrapper = ({
    label,
    value,
    children
}: PropsWithChildren<SelectWrapperProps>): JSX.Element => (
    <div
        className={classNames([
            'element',
            {
                empty: value === null || value === undefined,
                error: false,
                required: false,
                hasLabel: label
            }
        ])}
    >
        <div
            className={classNames(['select-wrapper', { 'select-multiple': true }])}
            data-test={dataTestValue(label)}
        >
            {children}
            <label>{label}</label>
        </div>
    </div>
);
